import {GlobalState} from "../GlobalState";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import axios from "axios";

interface LoginSuccessAppProps {
    setGlobalState : (state: GlobalState) => void;
    logoutUri: string
}

export default function LogoutApp(props: LoginSuccessAppProps) {
    const navigate = useNavigate();
    const {logoutUri, setGlobalState} = props;
    const [timeoutExpired, setTimeoutExpired] = useState<boolean>(false);
    localStorage.removeItem('session');
    useEffect(() => {
        axios.post(logoutUri, {}).then( (resp) => {
                // Wait a bit to propagate updates to the backend
                const timer = setTimeout(() => {setGlobalState({}); setTimeoutExpired(true)}, 1000);
                return () => clearTimeout(timer);
            }
        )
    }, [logoutUri, setGlobalState]);
    useEffect(() => {
        if (timeoutExpired && navigate) {
            return navigate("/");
        }
    }, [navigate, timeoutExpired]);
    return <div>Logging out...</div>;
}